import React, { useState, useEffect } from 'react';
import { ClaimTab } from 'app/modules/claim/ui/components/desktop/claim-tab/claim-tab';
import { verifName, verifNumber } from 'app/shared/util/verif-search.util';

import { useDispatch, useSelector } from 'react-redux';
import {
  getClaimsByClient,
  getClaimsClientsForActiveSubscription,
  getclaimsListBySubscriptionNumber,
  resetCaims,
  resetCaimsForContract,
  setPage,
} from 'app/modules/claim/service';
import { getSellingPoints } from 'app/modules/global/service/globalService';
import { IClaim } from 'app/modules/claim/model/search.model';
import { SellerSpace } from 'app/modules/contract/ui/components/desktop/seller-space/seller-space';
import { returnComponenet, TYPES_SEARCH } from '../../../modules/claim/ui/tools/constants';
import { getClaimsList, getFullClaimsList, getFullClaimsListForContract } from 'app/modules/claim/service/store/selectors';
import { IRootState } from 'app/shared/reducers';
import { useLocation } from 'react-router-dom';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { View } from 'app/modules/rules/domain/View';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import { getDataView } from 'app/modules/rules/service/rulesService';
import PaginationComp from 'app/shared/components/desktop/pagination/pagintationComp';
import ConfComponent from 'app/shared/components/common/conf-component';
import { getDesktopClaimFreeSelector, getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import ClaimPageSkeleton from 'app/shared/components/skeleton/desktop/s-claim-page';
import { replaceDocumentsCms } from 'app/shared/util/methode-util';

export const ClaimPage = () => {
  const deviceType: any = useSelector<IRootState>(state => state.global?.deviceType || '');
  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.CLAIMS, deviceType },
  };

  const [resultSearch, setResultSearch] = useState([]);

  const claimsList: any = useSelector(getClaimsList);
  const modalInformation: any = useSelector(getModalInformationButton)

  const claimLoading: boolean = useSelector<IRootState>(state => state.claim.loading) as boolean;
  const claimListPage: number = useSelector<IRootState>(state => state.claim.page) as number;
  const sellingPoints: any = useSelector<IRootState>(state => state.global.sellingPoints);
  const defaultSellingPointCode: any = useSelector<IRootState>(state => state.sellingPoint.connectedSellingPoint.code);
  const defaultSellingPointName: any = useSelector<IRootState>(state => state.sellingPoint.connectedSellingPoint.name);
  const cmsContractItem: any = useSelector<IRootState>(state => state.cms?.documents['desktop_claim_pdv_v2'] || []);
  const cmsContractAndClaimtStatus: any = useSelector<IRootState>(
    state => state.cms?.documents['desktop_contract_and_claim_status_v2'] || []
  );
  const claimsFreeCMS: any = useSelector(getDesktopClaimFreeSelector);
  const [inputSearch, setInputSearch] = useState('');
  const [criteria, setCriteria] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [sellingPointSearch, setSellingPointSearch] = useState(defaultSellingPointCode);
  const [claimListTodipslay, setClaimListTodipslay] = useState([]);
  const [sellingPointValue, setSellingPointValue] = useState(defaultSellingPointName);
  const [emptySearch, setEmptySearch] = useState(returnComponenet['FIRST']);
  const viewDataitems = useSelector(getDataViewRules(View.CLAIMS as any));
  const [openModalLength, setOpenModalLength] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [claimListTodisplay, setclaimListTodisplay] = useState([]);
  const dispatch = useDispatch();
  const location: any = useLocation();

  useEffect(() => {
    dispatch(getDataView(rulesContext));
    dispatch(getDocCMS('contract_items_table'));
    dispatch(getDocCMS('desktop_contract_and_claim_status_v2'));
    setclaimListTodisplay(claimsList);

  }, []);

  useEffect(() => {
   
    setclaimListTodisplay(claimsList);
  }, [claimsList]);

  useEffect(() => {
    if (defaultSellingPointCode && !sellingPointSearch) {
      setSellingPointSearch(defaultSellingPointCode);
      setSellingPointValue(defaultSellingPointName);
    }
  }, [defaultSellingPointCode]);

  const onInputChange = input => {
    if (input === '') setSellingPointSearch('');
    setSellingPointValue(input);
    if (input?.length && input.length > 2) {
      dispatch(getSellingPoints(input));
    }
  };

  const searchHandler = (searchValue: any): void => {
    setCriteria(searchValue.criteria);

    const number = searchValue?.searchValue || searchValue.detailSearchValue || searchValue || '';
    if (sellingPointSearch === '') {
      setShowModal(true);
    } else {
      if (number === '') {
        setEmptySearch(returnComponenet['EMPTY']);
      } else {
        setEmptySearch('ARRAY-RESULT');
        // eslint-disable-next-line prefer-const
        let claim = {} as IClaim;
        // eslint-disable-next-line prefer-const
        let typeSearch: any;

        if (verifName(number)) {
          claim['lastName'] = number;
          typeSearch = TYPES_SEARCH.SEARCH_NAME;
        } else {
          if (verifNumber(number)) {
            claim['number'] = number;
            typeSearch = TYPES_SEARCH.SEARCH_NUMBER;
          }
        }
        if (typeSearch) {
          dispatch(
            getClaimsByClient({
              ...claim,
              ...(sellingPointSearch && typeSearch !== TYPES_SEARCH.SEARCH_NUMBER ? { sellingPointCode: sellingPointSearch } : {}),
            })
          );
        }else {
          setShowErrorMessage(true)
          setclaimListTodisplay([]);

        }
      }
    }
  };
  const setListPage = (page: number) => {
    dispatch(setPage(page));
  };

  const resetClaimsHandler = () => {
    dispatch(resetCaims());
    setSellingPointSearch(defaultSellingPointCode);
    setSellingPointValue(defaultSellingPointName);
    dispatch(resetCaimsForContract());
    setClaimListTodipslay([]);
    setEmptySearch(returnComponenet['FIRST'])
  };

  useEffect(() => {
    const subscriptionNumber = location.state?.subNumber || location.state?.searchValue;
    if (!subscriptionNumber && location?.state?.criteria === undefined) {
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetClaimsClientsForActiveSubscription')) {
        dispatch(getClaimsClientsForActiveSubscription());
      }
    }

    if (viewDataitems?.dataRecoveryService?.find(service => service === 'DesktopClaimCustomerFree')) {
      dispatch(getDocCMS('desktop_claim_customer_v2'));
    }
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'DesktopClaimPdv')) {
      dispatch(getDocCMS('desktop_claim_pdv_v2'));
    }
    if (subscriptionNumber) {
      dispatch(getclaimsListBySubscriptionNumber(subscriptionNumber));
    }
  }, [location, viewDataitems]);

  function replaceDocumentsCmsPluralCostumer(): string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal {
    throw new Error('Function not implemented.');
  }

  return (
    <div>
      {claimLoading ? (
        <ClaimPageSkeleton />
      ) : (
        <>
          {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'SEARCH_SPACE_CLAIM') && (
            <div>
              <ConfComponent
                code="SEARCH_SPACE_CLAIM"
                listCode={viewDataitems?.componentDataList}
                props={{
                  sellingPointValue,
                  sellingPointSearch,
                  setSellingPointSearch,
                  sellingPoints,
                  value: inputSearch,
                  setValue: setInputSearch,
                  setResult: setResultSearch,
                  loading: claimLoading,
                  searchHandle: searchHandler,
                  onInputChange,
                  defaultSellingPoint: defaultSellingPointName,
                  resetClaimsHandler,
                  claimsFreeCMS,
                }}
              />
            </div>
          )}
 {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'SEARCH_SPACE_CLAIM')?.params?.SHOW_SEARCH_RESULT===true &&
      <div className="resultat_style d-flex justify-content-between">
         { claimsFreeCMS?.search_result && replaceDocumentsCms(claimListTodisplay?.length+" "+claimsFreeCMS?.search_result,"${s}",claimListTodisplay?.length <= 1 ? '' : 's')} 
        { claimsFreeCMS?.search_label && replaceDocumentsCmsPluralCostumer() }
      </div>}
    
          <ClaimTab
            onInputChange={onInputChange}
            setValue={setInputSearch}
            data={claimListTodisplay}
            fullclaimsList={claimListTodisplay }
            listPage={claimListPage}
            setListPage={setListPage}
            emptySearch={emptySearch}
            resetClaimsHandler={resetClaimsHandler}
            cmsContractItem={cmsContractItem}
            claimsFreeCMS={claimsFreeCMS}
            dataConf={viewDataitems}
            cmsContractAndClaimtStatus={cmsContractAndClaimtStatus}
            criteria={criteria}
          />

          {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'PAGINATION_SPACE') && (
            <PaginationComp data={claimsList} listPage={claimListPage} emptySearch={emptySearch} setListPage={setListPage} />
          )}

          <ModalWithAction
            showModal={openModalLength}
            setShowModel={setOpenModalLength}
            textBody={claimsFreeCMS?.check_length_name_search}
            action={() => {
              setOpenModalLength(false);
            }}
            btnActionLabel={modalInformation?.CLOSE_button}
          />



          <ModalWithAction
            showModal={showModal}
            setShowModel={setShowModal}
            textBody={claimsFreeCMS?.check_store_message}
            icon={modalInformation?.erreur_Icon?.url}
            action={() => {
              setShowModal(false);
            }}
            btnActionLabel={modalInformation?.CLOSE_button}
          />

{/* {showErrorMessage ? (
        
        <ModalWithAction
        showModal={true}
        setShowModel={setShowErrorMessage}
        textBody={"veuillez utiliser les nombres ou les critéres alphabitques"}
        action={() => {
          setShowErrorMessage(false)
        }}
        backButton={false}
      />
      ) : null}
 */}        </>
      )}
    </div>
  );
};
